<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isRouterAlive: true
    };
  },
  provide() {
    return {
      reload: this.reload,
      vuescrollOpt: {
        rail: {
          background: "#111",
          opacity: 0.3,
          size: "14px"
        },
        bar: {
          size: "8px",
          background: "#292E3B",
          hoverStyle: {
            background: "#31384B"
          },
          keepShow: true
        }
      }
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    //处理键盘事件 禁止后退键（Backspace）,密码或单行、多行文本框除外   
    banBackSpace(e){   
      var ev = e || window.event;
      var obj = ev.relatedTarget || ev.srcElement || ev.target || ev.currentTarget;
      if (ev.keyCode == 8) {
        var tagName = obj.nodeName;
        //如果标签不是input或者textarea则阻止Backspace
        if (tagName != 'INPUT' && tagName != 'TEXTAREA') {
          return false;
        }
        var tagType = obj.type.toUpperCase();//获取标签类型
        //input标签除了下面几种类型，全部阻止Backspace
        if (tagName == 'INPUT' && (tagType != 'TEXT' && tagType != 'TEXTAREA' && tagType != 'PASSWORD' && tagType != 'NUMBER')) {
          return false;
        }
        //input或者textarea输入框如果不可编辑则阻止Backspace
        if ((tagName == 'INPUT' || tagName == 'TEXTAREA') && (obj.readOnly == true || obj.disabled == true)) {
          return false;
        }
      }
    }   
  },
  mounted(){
    let _this = this; 
    document.onkeypress = _this.banBackSpace;   //禁止后退键 作用于Firefox、Opera   
    document.onkeydown = _this.banBackSpace;  //禁止后退键 作用于IE、Chrome   
  }
};
</script>

<style lang="less">
@import "~assets/less/common.less";
</style>



// WEBPACK FOOTER //
// src/App.vue